<form [formGroup]="registerForm">
    <div class="row">
        <div class="col">
            <label for="email">{{ 'auth.email' | translate }}</label>
            <input
                type="email"
                class="form-control"
                [placeholder]="'auth.email-placeholder' | translate"
                id="email"
                formControlName="UserName"
            />
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div
                class="alert alert-danger"
                role="alert"
                *ngIf="
                    !registerForm.controls['UserName'].valid &&
                    registerForm.controls['UserName'].touched
                "
            >
                <div
                    [hidden]="
                        !registerForm.controls['UserName'].errors.required
                    "
                >{{ 'auth.email-required' | translate }}</div>
                <div [hidden]="!registerForm.controls['UserName'].errors.email"
                    >{{ 'auth.email-invalid' | translate }}</div
                >
            </div>
        </div>
    </div>

    <!--PASSWORD -->
    <div class="row">
        <div class="col">
            <label for="password">{{ 'auth.password' | translate }}</label>
            <input
                type="password"
                id="password"
                class="form-control"
                formControlName="Password"
            />
            <on-required-field-display
                [field]="registerForm.controls['Password']"
            ></on-required-field-display>
        </div>
    </div>

    <!--CONFIRMATION -->
    <div class="row">
        <div class="col">
            <label for="confirmation">{{ 'auth.confirm-password' | translate }}</label>
            <input
                type="password"
                id="confirmation"
                class="form-control"
                formControlName="ConfirmPassword"
            />
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div
                class="alert alert-danger"
                *ngIf="
                    (!registerForm.controls['ConfirmPassword'].valid ||
                        registerForm.errors?.isPasswordDifferent) &&
                    registerForm.controls['ConfirmPassword'].touched
                "
            >
                <div
                    *ngIf="
                        registerForm.controls['ConfirmPassword'].errors
                            ?.required
                    "
                >{{ 'auth.confirmation-required' | translate }}</div>

                <div *ngIf="registerForm.errors?.isPasswordDifferent">
                    {{ 'auth.passwords-different' | translate }}
                </div>
            </div>
        </div>
    </div>

    <!--COUNTRY -->
    <div class="row">
        <div class="col">
            <label for="country">{{ 'auth.country' | translate }}</label>
            <on-country-select formControlName="Country"></on-country-select>
            <on-required-field-display
                [field]="registerForm.controls['Country']"
            ></on-required-field-display>
        </div>
    </div>

    <!--CURRENCY -->
    <div class="row">
        <div class="col">
            <label for="currency">{{ 'auth.currency' | translate }}</label>
            <on-currency-select formControlName="Currency"></on-currency-select>
            <on-required-field-display
                [field]="registerForm.controls['Currency']"
            ></on-required-field-display>
        </div>
    </div>
    <br />
    <!--CGU / CGV-->
    <div class="form-check cgu-check">
        <input
            class="form-check-input me-2"
            type="checkbox"
            value=""
            id="cgucheck"
            formControlName="cgu"
        />
        <label class="form-check-label" for="cgucheck">
            {{ 'auth.accept-terms-prefix' | translate }}
            <a target="_blank" [href]="'auth.terms-url' | translate"
                >{{ 'auth.terms-link-text' | translate }}</a
            >
        </label>
    </div>

    <div class="row">
        <div class="col">
            <div
                class="alert alert-danger"
                *ngIf="
                    !registerForm.controls['cgu'].valid &&
                    registerForm.controls['cgu'].touched
                "
            >
                <div [hidden]="!registerForm.controls['cgu'].errors.required">
                    {{ 'auth.accept-terms-error' | translate }}
                </div>
            </div>
        </div>
    </div>
</form>

<br />
<div class="row">
    <div class="col text-center">
        <button class="btn btn-primary" (click)="Register()">
            {{ 'auth.register' | translate }}
        </button>
    </div>
</div>
<div class="row">
    <div class="col text-center small-text">
        <span for="createAccount">{{ 'auth.already-have-account' | translate }}</span>
        <br />
        <a
            id="createAccount"
            routerLinkActive="active"
            routerLink="/login"
            [queryParams]="route.snapshot.queryParams"
            >{{ 'auth.sign-in' | translate }}</a
        >
    </div>
</div>
